import Utils from "./utils";
import fullpage from 'fullpage.js';
import $ from 'jquery';

class FullPageScroll{

	constructor(){

		// on passe en naviation normal en mobile
		// if(window.innerWidth < 780){
		// 	return false;
		// }

		// on va destroy quoi qu'il arrive
		if(typeof fullpage_api !== 'undefined'){
			fullpage_api.destroy('all');
		}

		//console.error($('#fullPageJsContainer'));
		if($('#fullPageJsContainer').length === 0){
			return false;
		}


		Utils.debug('Init fullpagescroll');

		let self = this;
		this.$navItems = $('.navFullPageJs__item');
		this.$border = $('.slide__border');
		this.$navContainer = $('.navFullPageJs');
		this.$circle = $('.navFullPageJs__item__link__circle')
		this.$menuBar = $('.main-menu__btn span')
		this.$label = $('.navFullPageJs__item__link__label')
		this.$container

		new fullpage(document.getElementById('fullPageJsContainer'), {
			anchors: ['accueil', 'legroupe', 'expertises', 'filiales', 'engagements', 'clients', 'references', 'contact', 'informations'],
			autoScrolling: true,
			licenseKey: '0E6E5A67-2B3244A1-9897D5E2-D28E2E39',
			onLeave: function(origin, destination, direction){
				self.setNavActive(destination.index);
				self.changeBorderColor(destination.item);
			},
		});

		this.setNavActive(fullpage_api.getActiveSection().index);

		this.$navItems.on('click', function () {

			self.$navItems.removeClass('navFullPageJs__item--active');
			self.$navItems.addClass('navFullPageJs__item--notActive');

			$(this).removeClass('navFullPageJs__item--notActive');
			$(this).addClass('navFullPageJs__item--active');
		});

		this.$navItems.on('mouseenter', function () {

			if($(this).hasClass('navFullPageJs__item--active')) {
				return false;
			}
			$(this).removeClass('navFullPageJs__item--notActive');
		});

		this.$navItems.on('mouseleave', function () {

			if($(this).hasClass('navFullPageJs__item--active')) {
				return false;
			}
			$(this).addClass('navFullPageJs__item--notActive');
		});
	}

	setNavActive(index) {

		let $initialItem = $(this.$navItems[index]);
		this.$navItems.removeClass('navFullPageJs__item--active');
		this.$navItems.addClass('navFullPageJs__item--notActive');

		$initialItem.removeClass('navFullPageJs__item--notActive');
		$initialItem.addClass('navFullPageJs__item--active');
	}

	changeBorderColor(item) {
		if($(item).hasClass('slide--white')) {
			this.$border.css('border-color', '#000000');
			this.$navContainer.css('color', '#000000');
			this.$circle.css('background', '#C20006');
			this.$label.css('color','#000000')
			this.$menuBar.css('background','#000000')
		} else if ($(item).hasClass('slide--red')){
			this.$circle.css('background', '#ffffff');
			this.$menuBar.css('background','#ffffff')
			this.$label.css('color','#ffffff')
		}
		else {
			this.$border.css('border-color', '#ffffff');
			this.$navContainer.css('color', '#ffffff');
			this.$circle.css('background', '#C20006');
			this.$menuBar.css('background','#ffffff')
			this.$label.css('color','#ffffff')
		}
	}
}


module.exports = FullPageScroll;

